export enum HTTP_HEADER {
  'X-CSRF-Token' = 'X-CSRF-Token',
}
